import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, first, take } from 'rxjs';
import { METRICS_ANSWER_WAS_HELPFUL_ENDPOINT, METRICS_ANSWER_WAS_NOT_HELPFUL_ENDPOINT, METRICS_QUESTION_ANSWERED_ENDPOINT, METRICS_QUESTION_ASKED_ENDPOINT, METRICS_QUESTION_FAILED_ENDPOINT, METRICS_QUESTION_RATED_ENDPOINT, METRICS_SENT_TO_HR_ENDPOINT, METRICS_SENT_TO_USER_ENDPOINT, METRICS_START_CONVERSATION_ENDPOINT, METRICS_SENT_GREETINGS_ENDPOINT, METRICS_NOT_SENT_TO_HR_ENDPOINT, METRICS_NOT_SENT_TO_USER_ENDPOINT } from '@app/common/api-endpoints.constants';
import { MetricAddRatingRequest, MetricAnswerQuestionRequest, MetricDialogueRequest, MetricInitialRequest, MetricQuestionAskedRequest } from '@app/models/metrics';

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  constructor(private http: HttpClient) { }

  startConversation(data: MetricInitialRequest): any {
    return this.http.post<boolean>(METRICS_START_CONVERSATION_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  questionAsked(data: MetricQuestionAskedRequest): any {
    return this.http.post<boolean>(METRICS_QUESTION_ASKED_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  questionAnswered(data: MetricAnswerQuestionRequest): any {
    return this.http.post<boolean>(METRICS_QUESTION_ANSWERED_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  greetingsSend(data: { dialogueId: string; sessionId: string; }) {
    return this.http.post<boolean>(METRICS_SENT_GREETINGS_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  questionFailed(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_QUESTION_FAILED_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  questionRated(data: MetricAddRatingRequest): any {
    return this.http.post<boolean>(METRICS_QUESTION_RATED_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  sentToHr(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_SENT_TO_HR_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  answerWasHelpful(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_ANSWER_WAS_HELPFUL_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  answerWasNotHelpful(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_ANSWER_WAS_NOT_HELPFUL_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  emailSentToUser(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_SENT_TO_USER_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  notSentToHr(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_NOT_SENT_TO_HR_ENDPOINT, data).pipe(take(1)).subscribe();
  }

  notSentToUser(data: MetricDialogueRequest): any {
    return this.http.post<boolean>(METRICS_NOT_SENT_TO_USER_ENDPOINT, data).pipe(take(1)).subscribe();
  }
}

